// extracted by mini-css-extract-plugin
export default {"ips_wrapper":"ips_wrapper___vhhKo"};